import AchievementStudentIcon1 from '@/assets/img/achievements/student/1.png';
import AchievementStudentIcon2 from '@/assets/img/achievements/student/2.png';
import AchievementStudentIcon3 from '@/assets/img/achievements/student/3.png';
import AchievementStudentIcon4 from '@/assets/img/achievements/student/4.png';
import AchievementStudentIcon5 from '@/assets/img/achievements/student/5.png';
import AchievementStudentIcon6 from '@/assets/img/achievements/student/6.png';
import AchievementStudentIcon7 from '@/assets/img/achievements/student/7.png';
import AchievementStudentIcon8 from '@/assets/img/achievements/student/8.png';
import AchievementStudentIcon9 from '@/assets/img/achievements/student/9.png';
import AchievementStudentIcon10 from '@/assets/img/achievements/student/10.png';
import AchievementStudentIcon11 from '@/assets/img/achievements/student/11.png';
import AchievementStudentIcon12 from '@/assets/img/achievements/student/12.png';
import AchievementStudentIcon13 from '@/assets/img/achievements/student/13.png';
import AchievementStudentIcon14 from '@/assets/img/achievements/student/14.png';
import AchievementStudentIcon15 from '@/assets/img/achievements/student/15.png';
import AchievementStudentIcon16 from '@/assets/img/achievements/student/16.png';
import AchievementStudentIcon17 from '@/assets/img/achievements/student/17.png';
import AchievementStudentIcon18 from '@/assets/img/achievements/student/18.png';
import AchievementStudentIcon19 from '@/assets/img/achievements/student/19.png';

import AchievementStudentUAMAP13 from '@/assets/img/achievements/student/UAMAP13.png';
import AchievementStudentUAMAP12 from '@/assets/img/achievements/student/UAMAP12.png';
import AchievementStudentUAMAP11 from '@/assets/img/achievements/student/UAMAP11.png';
import AchievementStudentUAMAP10 from '@/assets/img/achievements/student/UAMAP10.png';
import AchievementStudentUAMAP9 from '@/assets/img/achievements/student/UAMAP9.png';
import AchievementStudentUAMAP8 from '@/assets/img/achievements/student/UAMAP8.png';
import AchievementStudentUAMAP7 from '@/assets/img/achievements/student/UAMAP7.png';
import AchievementStudentUAMAP6 from '@/assets/img/achievements/student/UAMAP6.png';

import AchievementStudentSG12 from '@/assets/img/achievements/student/SG12.png';
import AchievementStudentSG11 from '@/assets/img/achievements/student/SG11.png';
import AchievementStudentSG10 from '@/assets/img/achievements/student/SG10.png';
import AchievementStudentSG9 from '@/assets/img/achievements/student/SG9.png';
import AchievementStudentSG8 from '@/assets/img/achievements/student/SG8.png';
import AchievementStudentSG7 from '@/assets/img/achievements/student/SG7.png';
import AchievementStudentSG6 from '@/assets/img/achievements/student/SG6.png';
import AchievementStudentSG5 from '@/assets/img/achievements/student/SG5.png';
import AchievementStudentSG4 from '@/assets/img/achievements/student/SG4.png';
import AchievementStudentSG3 from '@/assets/img/achievements/student/SG3.png';
import AchievementStudentSG2 from '@/assets/img/achievements/student/SG2.png';
import AchievementStudentSG1 from '@/assets/img/achievements/student/SG1.png';

// import AchievementStudentMSG12 from '@/assets/img/achievements/student/MSG12.png';
// import AchievementStudentMSG11 from '@/assets/img/achievements/student/MSG11.png';
import AchievementStudentMSG10 from '@/assets/img/achievements/student/MSG10.png';
import AchievementStudentMSG9 from '@/assets/img/achievements/student/MSG9.png';
import AchievementStudentMSG8 from '@/assets/img/achievements/student/MSG8.png';
import AchievementStudentMSG7 from '@/assets/img/achievements/student/MSG7.png';
import AchievementStudentMSG6 from '@/assets/img/achievements/student/MSG6.png';
import AchievementStudentMSG5 from '@/assets/img/achievements/student/MSG5.png';
import AchievementStudentMSG4 from '@/assets/img/achievements/student/MSG4.png';
import AchievementStudentMSG3 from '@/assets/img/achievements/student/MSG3.png';
import AchievementStudentMSG2 from '@/assets/img/achievements/student/MSG2.png';
import AchievementStudentMSG1 from '@/assets/img/achievements/student/MSG1.png';

import AchievementTeacherIcon1 from '@/assets/img/achievements/teacher/1.png';
import AchievementTeacherIcon2 from '@/assets/img/achievements/teacher/2.png';
import AchievementTeacherIcon3 from '@/assets/img/achievements/teacher/3.png';
import AchievementTeacherIcon4 from '@/assets/img/achievements/teacher/4.png';
import AchievementTeacherIcon5 from '@/assets/img/achievements/teacher/5.png';
import AchievementTeacherIcon6 from '@/assets/img/achievements/teacher/6.png';
import AchievementTeacherIcon7 from '@/assets/img/achievements/teacher/7.png';
// TODO: убрать комментарии, когда достижения будут работать
// import AchievementTeacherIcon8 from '@/assets/img/achievements/teacher/8.png';
// import AchievementTeacherIcon9 from '@/assets/img/achievements/teacher/9.png';
// import AchievementTeacherIcon10 from '@/assets/img/achievements/teacher/10.png';

import AchievementTeacherIcon11 from '@/assets/img/achievements/teacher/11.png';
import AchievementTeacherIcon12 from '@/assets/img/achievements/teacher/12.png';
import AchievementTeacherIcon13 from '@/assets/img/achievements/teacher/13.png';
import AchievementTeacherIcon14 from '@/assets/img/achievements/teacher/14.png';
import AchievementTeacherIcon15 from '@/assets/img/achievements/teacher/15.png';
import AchievementTeacherIcon16 from '@/assets/img/achievements/teacher/16.png';
import AchievementTeacherIcon17 from '@/assets/img/achievements/teacher/17.png';
import AchievementTeacherIcon18 from '@/assets/img/achievements/teacher/18.png';
import AchievementTeacherIcon19 from '@/assets/img/achievements/teacher/19.png';
import AchievementTeacherIcon20 from '@/assets/img/achievements/teacher/20.png';

import AchievementTeacherIcon21 from '@/assets/img/achievements/teacher/21.png';
import AchievementTeacherIcon22 from '@/assets/img/achievements/teacher/22.png';
import AchievementTeacherIcon23 from '@/assets/img/achievements/teacher/23.png';
import AchievementTeacherIcon24 from '@/assets/img/achievements/teacher/24.png';

import AchievementTeacherIconUAMAP1 from '@/assets/img/achievements/teacher/UAMAP1.png';
import AchievementTeacherIconUAMAP2 from '@/assets/img/achievements/teacher/UAMAP2.png';
import AchievementTeacherIconUAMAP3 from '@/assets/img/achievements/teacher/UAMAP3.png';

import AchievementTeacherIconSG1 from '@/assets/img/achievements/teacher/SG1.png';
import AchievementTeacherIconSG2 from '@/assets/img/achievements/teacher/SG2.png';
import AchievementTeacherIconSG3 from '@/assets/img/achievements/teacher/SG3.png';

export default {
  student: [
    {
      id: 'first_homework',
      title: 'Начало положено',
      desc: 'Ты сделал свою первую домашку, так держать!',
      icon: AchievementStudentIcon1,
    },
    {
      id: '2_homeworks_per_day',
      title: 'Раз, да еще раз!',
      desc: 'За сегодня это уже вторая домашняя работа. Тебя не остановить!',
      icon: AchievementStudentIcon2,
    },
    {
      id: 'homeworks_for_week_comleted',
      title: 'Проще простого!',
      desc:
        'Молодец, ты справляешься со всей домашней работой уже целую неделю!',
      icon: AchievementStudentIcon3,
    },
    {
      id: 'homeworks_for_month_comleted',
      title: 'Миссия выполнена',
      desc:
        'Мы в восторге от твоей выдержки! Ты выполнял всю домашнюю работу в течение месяца.',
      icon: AchievementStudentIcon4,
    },
    {
      id: '10_homeworks_completed',
      title: 'Мал да удал!',
      desc: 'Отлично! Ты уже сделал 10 домашних работ на портале.',
      icon: AchievementStudentIcon5,
    },
    {
      id: '50_homeworks_completed',
      title: 'Есть результат!',
      desc: 'Отлично! Ты уже сделал 50 домашних работ на портале.',
      icon: AchievementStudentIcon6,
    },
    {
      id: '100_homeworks_completed',
      title: 'Меня не остановить!',
      desc: 'Отлично! Ты уже сделал 100 домашних работ на портале.',
      icon: AchievementStudentIcon7,
    },
    {
      id: '500_homeworks_completed',
      title: 'Бесконечность не предел!',
      desc: 'Отлично! Ты уже сделал 500 домашних работ на портале.',
      icon: AchievementStudentIcon8,
    },
    {
      id: 'set_avatar',
      title: 'Улыбочку!',
      desc: 'Награда за установление или смену аватарки профиля',
      icon: AchievementStudentIcon9,
    },
    {
      //
      id: 'first_olimpic',
      title: 'Попытка не пытка',
      desc: 'Поздравляем с первым участием в олимпиаде!',
      icon: AchievementStudentIcon10,
    },
    {
      id: 'olimpic_prize_place',
      title: 'Дайте мне приз!',
      desc: 'Поздравляем с призовым местом в олимпиаде!',
      icon: AchievementStudentIcon11,
    },
    {
      id: 'olimpic_first_place',
      title: 'Лучше всех!',
      desc: 'Поздравляем с победой в олимпиаде!',
      icon: AchievementStudentIcon12,
    },
    {
      id: 'first_exam_access',
      title: 'Я готов!',
      desc: 'Ты решился сдать свой первый экзамен, так держать!',
      icon: AchievementStudentIcon13,
    },
    {
      id: 'access_3_month',
      title: 'Вместе веселее шагать...',
      desc: 'Ура! Ты занимаешься с нами уже 3 месяца подряд.',
      icon: AchievementStudentIcon14,
    },
    {
      id: 'access_6_month',
      title: 'Полгода, как один день.',
      desc: 'Ура! Ты занимаешься с нами уже 6 месяцев подряд.',
      icon: AchievementStudentIcon15,
    },
    {
      id: 'access_12_month',
      title: 'Не сверну с пути...',
      desc: 'Ура! Ты занимаешься с нами уже год.',
      icon: AchievementStudentIcon16,
    },
    {
      id: 'student_try_uamap',
      title: 'Мне не только посмотреть!',
      desc: 'Награда за первую попытку симулировать экзамен UAMAP',
      icon: AchievementStudentIcon17,
    },
    {
      id: 'student_try_sama_mental',
      title: 'Начало ментального пути...',
      desc:
        'Награда за первую попытку симулировать экзамен ментальная SAMA GLOBAL',
      icon: AchievementStudentIcon18,
    },
    {
      id: 'student_try_sama_abacus',
      title: 'В начале был абакус...',
      desc:
        'Награда за первую попытку симулировать экзамен SAMA GLOBAL на абакусе',
      icon: AchievementStudentIcon19,
    },

    {
      id: 'uamap_13',
      title: 'Медаль UAMAP 13',
      desc: 'Поздравляем, ты сдал экзамен UAMAP 13го уровня!',
      icon: AchievementStudentUAMAP13,
    },
    {
      id: 'uamap_12',
      title: 'Медаль UAMAP 12',
      desc: 'Поздравляем, ты сдал экзамен UAMAP 12го уровня!',
      icon: AchievementStudentUAMAP12,
    },
    {
      id: 'uamap_11',
      title: 'Медаль UAMAP 11',
      desc: 'Поздравляем, ты сдал экзамен UAMAP 11го уровня!',
      icon: AchievementStudentUAMAP11,
    },
    {
      id: 'uamap_10',
      title: 'Медаль UAMAP 10',
      desc: 'Поздравляем, ты сдал экзамен UAMAP 10го уровня!',
      icon: AchievementStudentUAMAP10,
    },
    {
      id: 'uamap_9',
      title: 'Медаль UAMAP 9',
      desc: 'Поздравляем, ты сдал экзамен UAMAP 9го уровня!',
      icon: AchievementStudentUAMAP9,
    },
    {
      id: 'uamap_8',
      title: 'Медаль UAMAP 8',
      desc: 'Поздравляем, ты сдал экзамен UAMAP 8го уровня!',
      icon: AchievementStudentUAMAP8,
    },
    {
      id: 'uamap_7',
      title: 'Медаль UAMAP 7',
      desc: 'Поздравляем, ты сдал экзамен UAMAP 7го уровня!',
      icon: AchievementStudentUAMAP7,
    },
    {
      id: 'uamap_6',
      title: 'Медаль UAMAP 6',
      desc: 'Поздравляем, ты сдал экзамен UAMAP 6го уровня!',
      icon: AchievementStudentUAMAP6,
    },

    {
      id: 'sama_abacus_12',
      title: 'Орден Абакус SAMA GLOBAL 12',
      desc: 'Поздравляем, ты сдал экзамен абакус SAMA GLOBAL 12го уровня!',
      icon: AchievementStudentSG12,
    },
    {
      id: 'sama_abacus_11',
      title: 'Орден Абакус SAMA GLOBAL 11',
      desc: 'Поздравляем, ты сдал экзамен абакус SAMA GLOBAL 11го уровня!',
      icon: AchievementStudentSG11,
    },
    {
      id: 'sama_abacus_10',
      title: 'Орден Абакус SAMA GLOBAL 10',
      desc: 'Поздравляем, ты сдал экзамен абакус SAMA GLOBAL 10го уровня!',
      icon: AchievementStudentSG10,
    },
    {
      id: 'sama_abacus_9',
      title: 'Орден Абакус SAMA GLOBAL 9',
      desc: 'Поздравляем, ты сдал экзамен абакус SAMA GLOBAL 9го уровня!',
      icon: AchievementStudentSG9,
    },
    {
      id: 'sama_abacus_8',
      title: 'Орден Абакус SAMA GLOBAL 8',
      desc: 'Поздравляем, ты сдал экзамен абакус SAMA GLOBAL 8го уровня!',
      icon: AchievementStudentSG8,
    },
    {
      id: 'sama_abacus_7',
      title: 'Орден Абакус SAMA GLOBAL 7',
      desc: 'Поздравляем, ты сдал экзамен абакус SAMA GLOBAL 7го уровня!',
      icon: AchievementStudentSG7,
    },
    {
      id: 'sama_abacus_6',
      title: 'Орден Абакус SAMA GLOBAL 6',
      desc: 'Поздравляем, ты сдал экзамен абакус SAMA GLOBAL 6го уровня!',
      icon: AchievementStudentSG6,
    },
    {
      id: 'sama_abacus_5',
      title: 'Орден Абакус SAMA GLOBAL 5',
      desc: 'Поздравляем, ты сдал экзамен абакус SAMA GLOBAL 5го уровня!',
      icon: AchievementStudentSG5,
    },
    {
      id: 'sama_abacus_4',
      title: 'Орден Абакус SAMA GLOBAL 4',
      desc: 'Поздравляем, ты сдал экзамен абакус SAMA GLOBAL 4го уровня!',
      icon: AchievementStudentSG4,
    },
    {
      id: 'sama_abacus_3',
      title: 'Орден Абакус SAMA GLOBAL 3',
      desc: 'Поздравляем, ты сдал экзамен абакус SAMA GLOBAL 3го уровня!',
      icon: AchievementStudentSG3,
    },
    {
      id: 'sama_abacus_2',
      title: 'Орден Абакус SAMA GLOBAL 2',
      desc: 'Поздравляем, ты сдал экзамен абакус SAMA GLOBAL 2го уровня!',
      icon: AchievementStudentSG2,
    },
    {
      id: 'sama_abacus_1',
      title: 'Орден Абакус SAMA GLOBAL 1',
      desc: 'Поздравляем, ты сдал экзамен абакус SAMA GLOBAL 1го уровня!',
      icon: AchievementStudentSG1,
    },

    // {
    //   id: 'sama_mental_12',
    //   title: 'Корона Ментальная SAMA GLOBAL 12',
    //   desc: 'Поздравляем, ты сдал экзамен ментальная SAMA GLOBAL 12го уровня!',
    //   icon: AchievementStudentMSG12,
    // },
    // {
    //   id: 'sama_mental_11',
    //   title: 'Корона Ментальная SAMA GLOBAL 11',
    //   desc: 'Поздравляем, ты сдал экзамен ментальная SAMA GLOBAL 11го уровня!',
    //   icon: AchievementStudentMSG11,
    // },
    {
      id: 'sama_mental_10',
      title: 'Корона Ментальная SAMA GLOBAL 10',
      desc: 'Поздравляем, ты сдал экзамен ментальная SAMA GLOBAL 10го уровня!',
      icon: AchievementStudentMSG10,
    },
    {
      id: 'sama_mental_9',
      title: 'Корона Ментальная SAMA GLOBAL 9',
      desc: 'Поздравляем, ты сдал экзамен ментальная SAMA GLOBAL 9го уровня!',
      icon: AchievementStudentMSG9,
    },
    {
      id: 'sama_mental_8',
      title: 'Корона Ментальная SAMA GLOBAL 8',
      desc: 'Поздравляем, ты сдал экзамен ментальная SAMA GLOBAL 8го уровня!',
      icon: AchievementStudentMSG8,
    },
    {
      id: 'sama_mental_7',
      title: 'Корона Ментальная SAMA GLOBAL 7',
      desc: 'Поздравляем, ты сдал экзамен ментальная SAMA GLOBAL 7го уровня!',
      icon: AchievementStudentMSG7,
    },
    {
      id: 'sama_mental_6',
      title: 'Корона Ментальная SAMA GLOBAL 6',
      desc: 'Поздравляем, ты сдал экзамен ментальная SAMA GLOBAL 6го уровня!',
      icon: AchievementStudentMSG6,
    },
    {
      id: 'sama_mental_5',
      title: 'Корона Ментальная SAMA GLOBAL 5',
      desc: 'Поздравляем, ты сдал экзамен ментальная SAMA GLOBAL 5го уровня!',
      icon: AchievementStudentMSG5,
    },
    {
      id: 'sama_mental_4',
      title: 'Корона Ментальная SAMA GLOBAL 4',
      desc: 'Поздравляем, ты сдал экзамен ментальная SAMA GLOBAL 4го уровня!',
      icon: AchievementStudentMSG4,
    },
    {
      id: 'sama_mental_3',
      title: 'Корона Ментальная SAMA GLOBAL 3',
      desc: 'Поздравляем, ты сдал экзамен ментальная SAMA GLOBAL 3го уровня!',
      icon: AchievementStudentMSG3,
    },
    {
      id: 'sama_mental_2',
      title: 'Корона Ментальная SAMA GLOBAL 2',
      desc: 'Поздравляем, ты сдал экзамен ментальная SAMA GLOBAL 2го уровня!',
      icon: AchievementStudentMSG2,
    },
    {
      id: 'sama_mental_1',
      title: 'Корона Ментальная SAMA GLOBAL 1',
      desc: 'Поздравляем, ты сдал экзамен ментальная SAMA GLOBAL 1го уровня!',
      icon: AchievementStudentMSG1,
    },
  ],
  teacher: [
    {
      id: 'first_student_exam_completed',
      title: 'Первый пошел!',
      desc: '1 ученик сдал любой экзамен',
      icon: AchievementTeacherIcon1,
    },
    {
      id: '10_student_exams_completed',
      title: 'Собрал команду!',
      desc: '10 учеников сдали любой экзамен',
      icon: AchievementTeacherIcon2,
    },
    {
      id: '50_student_exams_completed',
      title: 'Наставник',
      desc: '50 учеников сдали любой экзамен',
      icon: AchievementTeacherIcon3,
    },
    {
      id: 'homeworks_for_week_comleted',
      title: 'Показал как',
      desc: 'Поздравляем, ваш ученик справлялся с домашней работой всю неделю!',
      icon: AchievementTeacherIcon4,
    },
    {
      id: 'olimpic_prize_1',
      title: 'Поделился опытом',
      desc: 'Поздравляем, ваш ученик занял призовое место на олимпиаде!',
      icon: AchievementTeacherIcon5,
    },
    {
      //
      id: 'olimpic_prize_3',
      title: 'Сенсей',
      desc: 'Поздравляем, 3 ваших ученика заняли призовое место на олимпиаде!',
      icon: AchievementTeacherIcon6,
    },
    {
      id: 'olimpic_prize_5',
      title: 'Мудрый учитель',
      desc: 'Поздравляем, 5 ваших учеников заняли призовое место на олимпиаде!',
      icon: AchievementTeacherIcon7,
    },
    // TODO: убрать комментарии, когда достижения будут работать
    // {
    //   id: 'create_schedule_10',
    //   title: 'Начало положено',
    //   desc: 'Ура! Вы провели уже 10 занятий.',
    //   icon: AchievementTeacherIcon8,
    // },
    // {
    //   id: 'create_schedule_50',
    //   title: 'Все больше и больше',
    //   desc: 'Ура! Вы провели уже 50 занятий.',
    //   icon: AchievementTeacherIcon9,
    // },
    // {
    //   id: 'create_schedule_100',
    //   title: 'Дети любят меня',
    //   desc: 'Ура! Вы провели уже 100 занятий.',
    //   icon: AchievementTeacherIcon10,
    // },
    {
      id: '10_homeworks_created',
      title: 'Не время отдыхать!',
      desc: 'Неплохо! Вы задали уже 10 домашних заданий своим ученикам.',
      icon: AchievementTeacherIcon11,
    },
    {
      id: '100_homeworks_created',
      title: 'Знаю свое дело!',
      desc: 'Неплохо! Вы задали уже 100 домашних заданий своим ученикам.',
      icon: AchievementTeacherIcon12,
    },
    {
      id: '500_homeworks_created',
      title: 'Много не бывает!',
      desc: 'Неплохо! Вы задали уже 500 домашних заданий своим ученикам.',
      icon: AchievementTeacherIcon13,
    },
    {
      id: 'referal_created_student_1',
      title: '(+1)',
      desc: 'Поздравляем! Вы привели нового ученика на платформу!',
      icon: AchievementTeacherIcon14,
    },
    {
      id: 'referal_created_student_5',
      title: 'Вместе веселее',
      desc: 'Поздравляем! Вы привели уже 5 учеников на платформу!',
      icon: AchievementTeacherIcon15,
    },
    {
      id: 'referal_created_student_10',
      title: 'Мы - команда!',
      desc: 'Поздравляем! Вы привели уже 10 учеников на платформу!',
      icon: AchievementTeacherIcon16,
    },
    {
      id: 'referal_created_teacher_1',
      title: 'Уже не один!',
      desc: 'Поздравляем! Вы привели нового педагога на платформу!',
      icon: AchievementTeacherIcon17,
    },
    {
      id: 'referal_created_teacher_3',
      title: 'Все свои!',
      desc: 'Поздравляем! Вы привели уже 3 педагога на платформу!',
      icon: AchievementTeacherIcon18,
    },
    {
      id: 'referal_created_teacher_5',
      title: 'Люблю свою работу!',
      desc: 'Поздравляем! Вы привели уже 5 педагогов на платформу!',
      icon: AchievementTeacherIcon19,
    },
    {
      id: 'pay_for_student_access',
      title: 'Вклад в будущее',
      desc:
        'Вы только что оплатили подписку вашего ученика на платформу. Получите свою награду!',
      icon: AchievementTeacherIcon20,
    },

    {
      id: 'pay_for_student_olimpic',
      title: 'Проявление заботы',
      desc:
        'Вы только что оплатили участие вашего ученика в олимпиаде. Получите свою награду!',
      icon: AchievementTeacherIcon21,
    },
    {
      id: 'topup_account',
      title: 'Точно пригодится!',
      desc: 'Вы пополнили баланс и за это получаете небольшой презент!',
      icon: AchievementTeacherIcon22,
    },
    {
      id: 'set_avatar',
      title: 'Улыбочку!',
      desc: 'Награда за установление или смену аватарки профиля',
      icon: AchievementTeacherIcon23,
    },
    {
      id: 'complete_profile',
      title: 'Свой человек!',
      desc: 'Награда за заполнение всех полей в профиле',
      icon: AchievementTeacherIcon24,
    },
    {
      id: 'uamap_1',
      title: 'Сертификат UAMAP 1',
      desc: 'Поздравляем, Вы справились с экзаменом UAMAP 1го уровня',
      icon: AchievementTeacherIconUAMAP1,
    },
    {
      id: 'uamap_2',
      title: 'Сертификат UAMAP 2',
      desc: 'Поздравляем, Вы справились с экзаменом UAMAP 2го уровня',
      icon: AchievementTeacherIconUAMAP2,
    },
    {
      id: 'uamap_3',
      title: 'Сертификат UAMAP 3',
      desc: 'Поздравляем, Вы справились с экзаменом UAMAP 3го уровня',
      icon: AchievementTeacherIconUAMAP3,
    },
    {
      id: 'sama_3',
      title: '3 звезды SAMA GLOBAL',
      desc: 'Поздравляем, вы получили 3 звезды SAMA GLOBAL',
      icon: AchievementTeacherIconSG3,
    },
    {
      id: 'sama_5',
      title: '2 звезды SAMA GLOBAL',
      desc: 'Поздравляем, Вы получили 2 звезды SAMA GLOBAL',
      icon: AchievementTeacherIconSG2,
    },
    {
      id: 'sama_7',
      title: 'Звезда SAMA GLOBAL',
      desc: 'Поздравляем, Вы получили 1 звезду SAMA GLOBAL',
      icon: AchievementTeacherIconSG1,
    },
  ],
};
